import { ISeoCache } from "../types/types";

export enum EnumSpecsSeoModelPage {
  CAR_LANDING = "CarLanding",
  CAR_MAKE = "CarMake",
  CAR_MODEL = "CarModel",
  CAR_YEAR = "CarYear",
  CAR_TYPE = "CarType",
  MOBILE_LANDING = "MobileLanding",
  TABLET_LANDING = "TabletLanding",
  MOBILE_MAKE = "MobileMake",
  MOBILE_MODEL = "MobileModel",
  TABLET_MAKE = "TabletMake",
  TABLET_MODEL = "TabletModel",
  SC_CAR_MAKE = "serviceCenterCarMake",
  SC_SERVICE = "serviceCenterCarService",
  SC_CITY = "serviceCenterCity",
  SC_NEIGNBORHOOD = "serviceCenterNeignborhood",
  SC_SERIVCES_LIST = "serviceCenterServicesList",
  SC_CAR_MAKE_LIST = "serviceCenterCarMakeList",
  SC_LANDING = "serviceCenterLanding",

  SC_CENTER_PAGE = "serviceCenterCenterPage",
  HC_SUPPORT_CENTER_PAGE = "supportCenterPage",
  HC_CONTACT_US_PAGE = "contactUsPage",
  HC_CATEGORY_PAGE = "categoryPage",
  HC_SEARCH_PAGE = "searchPage",
}

export default class SpecsSeoModel {
  declare id: number;
  declare title_ar: string;
  declare title_en: string;

  declare meta_desc_ar: string;
  declare meta_desc_en: string;

  declare slogan_1_ar: string;
  declare slogan_1_en: string;
  declare slogan_2_ar: string;
  declare slogan_2_en: string;
  declare description_ar: string;
  declare description_en: string;
  declare main_image_uri: string;
  declare page_name: string;
}

export const getByPageName = (
  seoCache: ISeoCache,
  pageName: EnumSpecsSeoModelPage
): SpecsSeoModel => {
  return seoCache.getSpecsSeoRecord(pageName);
};
